import { Emdash } from "../Punctuation/Emdash";
import { Tooltip } from "../Tooltip";

// // // //

export function DataGridDescriptionCell(props: {
    text: string | null;
    maxLength: number;
}) {
    const { text, maxLength } = props;

    if (!text) return <Emdash />;

    const isTruncated = text.length > maxLength;
    const snippet = isTruncated
        ? `${text.slice(0, maxLength).trimEnd()}…`
        : text;

    if (!isTruncated) {
        return <span className="dg-overflow">{snippet}</span>;
    }

    return (
        <Tooltip
            placement="top"
            tooltipContent={
                <p className="px-3 py-1.5 text-sm max-w-sm">{text}</p>
            }
        >
            {({ setTriggerRef }) => (
                <span ref={setTriggerRef} className="dg-overflow">
                    {snippet}
                </span>
            )}
        </Tooltip>
    );
}
